var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-role',{attrs:{"role":_vm.role}})}
var staticRenderFns = []

export { render, staticRenderFns }